import { render, staticRenderFns } from "./DesignData.vue?vue&type=template&id=4909f032&scoped=true"
import script from "./DesignData.vue?vue&type=script&lang=js"
export * from "./DesignData.vue?vue&type=script&lang=js"
import style0 from "./DesignData.vue?vue&type=style&index=0&id=4909f032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4909f032",
  null
  
)

export default component.exports